'use client'

import { Button } from '@repo/design-system-cf/components/button'
import { IconBookmark, IconCheckCircle } from '@repo/design-system-cf/components/icons'
import { useTranslations } from 'next-intl'
import { useAjaxWp } from 'hooks/use-ajax-wp'
import toast from 'react-hot-toast'

export const SaveToMyDownloadButton = ({ pid }: { pid: string }) => {
  const { query, loading, data } = useAjaxWp<{
    message: string
    status: number
  }>('save_to_downloads_action', 'follow_action_nonce_field')

  const t = useTranslations('pages.daily-gifts.categories')

  const handleSaveToMyDownload = async () => {
    await query(
      {
        pid,
      },
      {
        onSuccess: data => {
          toast.success(data?.message)
        },
        onError: error => {
          toast.error(error || t('save_to_downloads_error'))
        },
      },
    )
  }

  return (
    <Button
      variant={'secondary-grey'}
      iconLeft={data?.status === 1 ? <IconCheckCircle /> : <IconBookmark />}
      onClick={handleSaveToMyDownload}
      loading={loading}
      disabled={loading}
      textClassName="truncate"
    >
      <span className="uppercase font-bold">
        {data?.status === 1 ? t('saved_to_downloads_success_title') : t('save_to_downloads')}
      </span>
    </Button>
  )
}
